export { default } from 'styled-up/dist/Alert';
